import {
  isFeatureEnabledForUser,
  type FeatureKey,
  type FeatureUser,
} from '@lynx-crypto/contracts/feature-flags';
import { useAuthStore } from '../stores/authStore';
import { useFeatureFlagStore } from '../stores/featureFlagStore';

/**
 * THE web-ui entry point for feature-flag gating. Returns a `canUse(feature)`
 * predicate bound to the current user + live flags, using the SHARED resolver
 * from @lynx-crypto/contracts — the identical function the backend enforces with.
 *
 * Usage:
 *   const { canUse } = useFeatureAccess();
 *   if (!canUse('hunt')) return <Locked />;
 */
export function useFeatureAccess(): {
  canUse: (feature: FeatureKey) => boolean;
  loaded: boolean;
} {
  const user = useAuthStore((s) => s.user);
  const flags = useFeatureFlagStore((s) => s.flags);
  const loaded = useFeatureFlagStore((s) => s.loaded);

  const featureUser: FeatureUser = user
    ? { role: user.role, researchTier: user.researchTier ?? null }
    : null;

  const canUse = (feature: FeatureKey): boolean =>
    isFeatureEnabledForUser(feature, featureUser, flags);

  return { canUse, loaded };
}
